import React from 'react'
import { useTranslation } from 'react-i18next'
import "./endToEndControl.scss"

function EndToEndControl() {
  const { t } = useTranslation()
  return (
    <div className='container-end-to-end-control'>
      <div className="texts-end-to-end-control">
        <h1>{t("education.e2e_control.title")}</h1>
        <p>{t("education.e2e_control.section_text")}</p>
      </div>
    </div>
  )
}

export default EndToEndControl